module.exports = __webpack_public_path__ + "b6c047a1f826e0bd511eb9be320eff64.pdf";